// Module
var code = "<div class=\"sb-loading\" ng-class=\"{'mini': mini}\"> <div class=\"one\"></div> <div class=\"two\"></div> <div class=\"three\"></div> </div> ";
// Exports
var _module_exports =code;;
var path = '/var/lib/jenkins/workspace/Sablono_sb-bimtime_master/app/scripts/common/ui-elements/directives/sbLoading/sb_loading.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;